import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from "@parkschannel/ui";
import { ImgixImage } from "../ImgixImage";
export const NextAvatar = (props)=>{
    if ("children" in props) {
        return /*#__PURE__*/ _jsx(Avatar, {
            ...props
        });
    } else if (props.src) {
        return /*#__PURE__*/ _jsx(Avatar, {
            size: props.size,
            className: props.className,
            children: /*#__PURE__*/ _jsx(ImgixImage, {
                src: props.src,
                alt: "avatar",
                width: 168,
                height: 168,
                className: "object-cover"
            })
        });
    } else {
        return /*#__PURE__*/ _jsx(Avatar, {
            size: props.size,
            className: props.className,
            src: null
        });
    }
};
